import { Loader } from '@/ui'
import './AnnualTaxOverview.scss'

import AnnualTaxTskEntryPoint from './AnnualTaxTskEntryPoint'
import YearEndHome from './year-end-home'
import FreeTrialAnnualTaxPreview from './FreeTrialAnnualTaxPreview'
import LateJoinerOptedOutPage from './LateJoinerOptedOutPage'
import DisqualifiedSplashScreen from './DisqualifiedSplashScreen'
import {
  AnnualTaxOverviewPage,
  useAnnualTaxOverviewPage,
} from '@/features/taxes/annual-taxes/overview/hooks'
import { UpgradeToPremiumCard } from '@/features/taxes/upsell/UpgradeToPremiumCard'
import { OffSeasonUpsellCard } from '@/features/taxes/upsell/OffSeasonUpsellCard'
import { DisqualifiedPostCutoffScreen } from './DisqualifiedPostCuttoffScreen'
import { NextYearTaxCenter } from './NextYearTaxCenter'

export const AnnualTaxesOverviewPanel = () => {
  const annualTaxPage = useAnnualTaxOverviewPage()

  switch (annualTaxPage) {
    case AnnualTaxOverviewPage.loading:
      return <Loader />
    case AnnualTaxOverviewPage.upgradeToPremium:
      return <UpgradeToPremiumCard />
    case AnnualTaxOverviewPage.upgradeToPremiumOffSeason:
      return <OffSeasonUpsellCard />
    case AnnualTaxOverviewPage.disqualified:
      return <DisqualifiedSplashScreen />
    case AnnualTaxOverviewPage.yearEndHome:
      return <YearEndHome />
    case AnnualTaxOverviewPage.lateJoinerOptedOut:
      return <LateJoinerOptedOutPage />
    case AnnualTaxOverviewPage.nextYearTaxCenter:
      return <DisqualifiedPostCutoffScreen />
    case AnnualTaxOverviewPage.freeTrialAnnualTaxPreview:
      return <FreeTrialAnnualTaxPreview />
    case AnnualTaxOverviewPage.annualTaxTskEntryPoint:
      return <AnnualTaxTskEntryPoint />
    case AnnualTaxOverviewPage.taxSeasonNotOpen:
      return <NextYearTaxCenter />
    default:
      return annualTaxPage satisfies never
  }
}
